export default "__VITE_ASSET__60a77fce__"